"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var EFFECTS = {
  boxShadow: {
    button: '0 0.625rem 0.9375rem #00000033',
    cards: '0 0.25rem 0.9375rem #00000033'
  }
};
var _default = EFFECTS;
exports["default"] = _default;